export default __webpack_public_path__ + "static/media/header-XC90.5a21b63b.jpg";